import { useCallback, useEffect, useState } from "react";

/**
 * Small data-loading hook shared by every admin section.
 * Handles loading / error state and exposes setData for optimistic updates.
 */
export function useAdminResource<T>(
  loader: () => Promise<T>,
  initial: T,
  deps: unknown[] = [],
) {
  const [data, setData]       = useState<T>(initial);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const result = await loader();
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load data.");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, setData, loading, error, reload };
}